import axios from "../../utils/axios";
import {
  ADD_USER,
  DELETE_COMPANY_USER,
  HANDLE_ACCOUNT_UPDATED,
  HANDLE_CHANGED_PASSWORD,
  SET_COMPANY_USERS,
  SET_ERRORS,
  SET_USER,
  SET_USER_ADDED
} from "./actionTypes";
import {setCurrentUser} from "./auth";
import {toast} from "react-toastify";

// Get all company users
export const getCompanyUsers = () => dispatch => {
  axios
      .get('get-company-all-users/?show_all')
      .then(response => {
        const data = {...response.data};
        const warehouseAdmins = [...data.warehouse_admins];
        const company_users = [...data.company_users];
        const invited_warehouse_admins = [...data.invited_warehouse_admins];

        dispatch(setCompanyUsers({
          warehouseAdmins,
          company_users,
          invited_warehouse_admins
        }));
      })
      .catch(console.log);
};

// Set all company users to store
const setCompanyUsers = users => ({
  type: SET_COMPANY_USERS,
  payload: users
});

// Update user
export const updateUser = (id, userData) => dispatch => {
  axios
      .patch(`users/${id}/`, userData)
      .then(response => dispatch(setUser(response.data)))
      .catch(console.log)
};

// Set single user to the store
const setUser = userData => ({
  type: SET_USER,
  payload: userData
});

// Delete user
export const deleteUser = id => dispatch => {
  axios
      .delete(`users/${id}/`)
      .then(response => {
        if (response.status === 204) {
          dispatch(deleteCompanyUser(id))
        }
      })
      .catch(console.log);
};

// Delete company user
const deleteCompanyUser = id => ({
  type: DELETE_COMPANY_USER,
  payload: id
});

// Invite company user
export const inviteCompanyUser = (userData, closeModal) => dispatch => {
  axios
      .post('invite-user-warehouse/', userData)
      .then(response => {
        if (response.status === 201) {
          dispatch({
            type: ADD_USER,
            payload: userData
          });
          closeModal('add', false, true);
        }
      })
      .catch(error => {
        dispatch(setErrors(error.response.data));
      });
};

// Set user added state for notifications
export const setUserAdded = payload => ({
  type: SET_USER_ADDED,
  payload
});

// Set errors
export const setErrors = errors => ({
  type: SET_ERRORS,
  payload: errors
});

export const updateAccount = (userId, companyId, companyData, userData) => dispatch => {
  let updatedUserData = null;
  const oldUser = JSON.parse(atob(localStorage.getItem('user')));

  axios
      .patch(`/users/${userId}/`, userData)
      .then(response => {
        updatedUserData = response.data;
      })
      .then(() => {
        axios
            .patch(`company/${companyId}/`, companyData)
            .then(response => {
              const payload = {
                ...oldUser,
                first_name: updatedUserData.first_name,
                last_name: updatedUserData.last_name,
                email: updatedUserData.email,
                company: {
                  ...oldUser.company,
                  image: response.data.image,
                  name: response.data.name
                }
              };

              dispatch(setCurrentUser(payload));
              dispatch(handleAccountUpdated(true));
              localStorage.setItem('user', btoa(JSON.stringify(payload)));
              toast.success('Account successfully updated.', {
                position: toast.POSITION.TOP_RIGHT,
                className: ''
              });
            })
            .catch(console.log)
      })
      .catch(error => dispatch(handleAccountUpdated(error.response)));
};

const handleAccountUpdated = data => ({
  type: HANDLE_ACCOUNT_UPDATED,
  payload: data
});

export const changePassword = (userId, data) => dispatch => {
  axios
      .patch(`users/${userId}/change_password/`, data)
      .then(response => dispatch({
        type: HANDLE_CHANGED_PASSWORD,
        payload: response
      }))
      .catch(error => dispatch({
        type: HANDLE_CHANGED_PASSWORD,
        payload: error
      }));
};


// WEBPACK FOOTER //
// ./src/store/actions/user.js